import { render } from "./createplan_page.vue?vue&type=template&id=810120ec&scoped=true"
import script from "./createplan_page.vue?vue&type=script&lang=js"
export * from "./createplan_page.vue?vue&type=script&lang=js"

import "./createplan_page.vue?vue&type=style&index=0&id=810120ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-810120ec"]])

export default __exports__